"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _reactSortableHoc = require("react-sortable-hoc");

var _Handle = _interopRequireDefault(require("@insided/shared/icons/Handle"));

var DragHandle = (0, _reactSortableHoc.SortableHandle)(function () {
  return (0, _preact.h)("span", {
    className: "drag-handle--union"
  }, (0, _preact.h)(_Handle.default, null));
});
var _default = DragHandle;
exports.default = _default;